export type ListPickerKeyResult =
  | { type: "move"; index: number }
  | { type: "select"; index: number }
  | { type: "close" }
  | { type: "ignore" };

/**
 * Tastatur im Listenfeld. Buchstaben ändern die Auswahl nicht (keine Buchstabenauswahl).
 */
export function listPickerKeyAction(
  key: string,
  index: number,
  length: number
): ListPickerKeyResult {
  if (length <= 0) return { type: "ignore" };
  const current = Math.min(Math.max(index, 0), length - 1);
  if (key === "ArrowDown") {
    return { type: "move", index: Math.min(length - 1, current + 1) };
  }
  if (key === "ArrowUp") {
    return { type: "move", index: Math.max(0, current - 1) };
  }
  if (key === "Enter") return { type: "select", index: current };
  if (key === "Escape") return { type: "close" };
  return { type: "ignore" };
}

export function focusHost(node: unknown) {
  if (
    node &&
    typeof node === "object" &&
    "focus" in node &&
    typeof (node as { focus: unknown }).focus === "function"
  ) {
    (node as { focus: () => void }).focus();
  }
}
